import { useCallback, useState } from 'react';

export type UseSimulateParseBeeRowQueryReturnType = ReturnType<typeof useSimulateParseBeeRowQuery>;

/**
 * Hook to simulate parsing a bee row. This is used for displaying appropriate UI states (e.g. `isLoading`) while the BEE SDK is parsing a row.
 * This is especially used when creating a saved row.
 */
export const useSimulateParseBeeRowQuery = () => {
  const [html, setHTML] = useState<string | null>(null);
  const [beeBuilderMetadata, setBeeBuilderMetadata] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const reset = useCallback(() => {
    setIsLoading(false);
    setHTML(null);
    setBeeBuilderMetadata(null);
  }, [setIsLoading, setHTML, setBeeBuilderMetadata]);

  const start = useCallback(() => {
    reset();
    setIsLoading(true);
  }, [setIsLoading, reset]);

  const stop = useCallback(
    ({ beeMetadataContent, htmlContent }: { htmlContent: string; beeMetadataContent: string }) => {
      setIsLoading(false);
      setHTML(htmlContent);
      setBeeBuilderMetadata(beeMetadataContent);
    },
    [setIsLoading, setHTML, setBeeBuilderMetadata],
  );

  return {
    isLoading,
    data: html && beeBuilderMetadata ? { html, beeBuilderMetadata } : null,
    start,
    stop,
    reset,
  };
};
